export default __webpack_public_path__ + "static/media/login-time.e7d4aa3a.svg";